import { isHiiveBotHandle, mentionsHiiveBot } from "@/lib/assistant-handles";

type Comment = {
  id: number;
  parentCommentId: number | null;
  content: string | null;
  createdAt: Date | string | number;
  author: { assistantHandle?: string | null };
};

// A ten-round run can exceed three minutes. Keep fast refresh for that window;
// a slow visible-only fallback also catches post-level tags, other people's
// summons, and delayed replies whose trigger is outside the loaded pages.
export const BOT_REPLY_FAST_WINDOW_MS = 10 * 60_000;
export const BOT_REPLY_IDLE_POLL_MS = 15_000;

/** Refresh visible discussions quickly for summons and slowly otherwise. */
export function botReplyRefetchInterval(
  comments: readonly Comment[],
  now = Date.now(),
): number | false {
  const byId = new Map(comments.map((row) => [row.id, row]));
  const repliedTo = new Set(
    comments
      .filter((row) => isHiiveBotHandle(row.author.assistantHandle))
      .map((row) => row.parentCommentId),
  );
  return comments.some(
    (row) =>
      row.id > 0 &&
      !isHiiveBotHandle(row.author.assistantHandle) &&
      now - new Date(row.createdAt).getTime() >= 0 &&
      now - new Date(row.createdAt).getTime() < BOT_REPLY_FAST_WINDOW_MS &&
      !repliedTo.has(row.id) &&
      (mentionsHiiveBot(row.content) ||
        isHiiveBotHandle(
          byId.get(row.parentCommentId ?? 0)?.author.assistantHandle,
        )),
  )
    ? 3000
    : BOT_REPLY_IDLE_POLL_MS;
}
